import type { TicketDeliveryProduct } from "@kiraah-shared/common";

export function mobileDeliveryProductTitle(productLine: TicketDeliveryProduct): string {
  return (
    productLine.Product?.Label?.trim() ||
    productLine.ProductLabel?.trim() ||
    productLine.Comment?.trim() ||
    productLine.EquipmentType?.Label?.trim() ||
    productLine.VehicleType?.Label?.trim() ||
    productLine.EquipmentVehicle?.Designation?.trim() ||
    productLine.EquipmentVehicle?.RegistrationNumber?.trim() ||
    productLine.EquipmentVehicle?.NumeroParc?.trim() ||
    productLine.EquipmentVehicle?.Model?.Label?.trim() ||
    "—"
  );
}

export function mobileDeliveryProductSubtitle(productLine: TicketDeliveryProduct): string {
  return (
    productLine.Product?.SKUCode?.trim() ||
    productLine.Product?.Barcode?.trim() ||
    productLine.Product?.SerialNumber?.trim() ||
    productLine.Product?.Description?.trim() ||
    productLine.EquipmentVehicle?.SerialNumber?.trim() ||
    productLine.EquipmentVehicle?.IdentificationInfo?.trim() ||
    productLine.EquipmentType?.Description?.trim() ||
    productLine.VehicleType?.Description?.trim() ||
    ""
  );
}
